import './styles.css';
import building from '../images/IMG_8094.jpg'

function HomePage( { sectionZeroRef } ) {

    const scrollToId = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const yOffset = -60; // same offset as header height
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    return (
        <div id={'HomePage'}>
            <div className={'left'}>
                <h2>Williams & Williams, P.C.</h2>
                <h1>Justice You Can Count On</h1>
                <h3 style={{margin: '40px 0 30px 0'}}>
                    We deliver fast, effective legal results with personalized support designed to meet your unique
                    needs. Get the help you need, when you need it most.
                </h3>
                <div className={'container'}>
                    <button onClick={() => scrollToId('Footer')}>
                        Contact Us
                    </button>
                    <button className={'secondary'} onClick={() => scrollToId('AboutPage')}>
                        Learn More
                    </button>
                </div>
            </div>
            <div className={'right'}>
                <img src={building} alt={'Office'}/>
                <div>
                    <h3>Family Owned Since</h3>
                    <h1>1966</h1>
                </div>
            </div>
        </div>
    )
        ;
}

export default HomePage;
